import LabelT from '@components/tailwind-components/Label/LabelT';
import clsx from 'clsx';
import type React from 'react';
import { Controller } from 'react-hook-form';
import type { IScheduleProps } from '../../../interfaces/IInputProps';

export const TimeInput: React.FC<IScheduleProps> = ({
  name,
  control,
  watch,
  label,
  labelClassName = '',
  inputClassName = '',
}) => {
  const delimiter = ':';

  const defaultStyles = [
    'flex-none',
    'w-[60px]',
    'h-[35px]',
    'py-1.5',
    'px-2.5',
    'border',
    'border-gray-200',
    'text-sm',
    'leading-5',
    'font-normal',
    'outline-none',
    'focus:border-primary-base',
    'focus:outline-none',
    'focus:shadow-none',
  ];

  return (
    <div
      className={`relative before-content ${inputClassName}`}
      data-before={delimiter}>
      <div className='mt-1'>
        <LabelT text={label} className={labelClassName} />
        <div className='flex mt-1'>
          <Controller
            control={control}
            name={name}
            render={({ field: { onChange } }) => {
              // * Required because of value not updating when switching tabs (switching controllers)
              // * More info: https://stackoverflow.com/questions/71690821/how-to-trigger-re-render-with-setvalue-using-react-hook-form#answer-72709726
              const value = watch(name);
              const [hoursValue, minutesValue] = value.includes(delimiter)
                ? value.split(delimiter)
                : ['', ''];

              return (
                <>
                  <input
                    dir='rtl'
                    id={`${name}.0`}
                    type='number'
                    className={clsx(
                      defaultStyles,
                      `first:border-r-0 rounded-tl-md rounded-bl-md ${inputClassName}`,
                    )}
                    min={0}
                    max={24}
                    value={hoursValue}
                    onChange={(val) => {
                      const newHoursValue = val.target.value;
                      const changedValue = `${newHoursValue}${delimiter}${minutesValue}`;
                      return onChange(changedValue);
                    }}
                  />
                  <input
                    id={`${name}.1`}
                    type='number'
                    className={clsx(
                      defaultStyles,
                      `last:border-l-0 last:rounded-r-md last:m-0 rounded-tr-md rounded-br-md ${inputClassName}`,
                    )}
                    min={0}
                    max={60}
                    value={minutesValue}
                    onChange={(val) => {
                      const newMinutesValue = val.target.value;
                      const changedValue = `${hoursValue}${delimiter}${newMinutesValue}`;
                      return onChange(changedValue);
                    }}
                  />
                </>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TimeInput;
